import { NavLink, Outlet } from 'react-router-dom';

import { BASE_URL } from '../api/client';
import { useAuth } from '../auth/useAuth';

const LINKS = [
  { to: '/', label: 'Dashboard', icon: '◱' },
  { to: '/products', label: 'Products', icon: '▤' },
  { to: '/recommendations', label: 'Price moves', icon: '⇅' },
  { to: '/insights', label: 'Insights', icon: '◔' },
  { to: '/competitors', label: 'Competitors', icon: '⚖' },
  { to: '/crawler', label: 'Crawler', icon: '◷' },
  { to: '/zenrows', label: 'ZenRows usage', icon: '◈' },
  { to: '/logs', label: 'Activity log', icon: '≡' },
  { to: '/settings', label: 'Settings', icon: '⚙' },
];

export function AppShell() {
  const { username, signOut } = useAuth();

  return (
    <div className="shell">
      <nav className="nav">
        <div className="nav__brand">
          <div className="nav__mark">H</div>
          <div>
            <div className="nav__title">Price Radar</div>
            <div className="nav__subtitle">Heureka.sk</div>
          </div>
        </div>

        <div className="nav__list">
          {LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) => `nav__link${isActive ? ' nav__link--active' : ''}`}
            >
              <span className="nav__icon" aria-hidden="true">
                {link.icon}
              </span>
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="nav__footer">
          <div className="nav__session">
            <span>
              Signed in as <strong>{username}</strong>
            </span>
            <button type="button" className="button" onClick={signOut}>
              Sign out
            </button>
          </div>
          API
          <div style={{ wordBreak: 'break-all', marginTop: 2 }}>{BASE_URL}</div>
        </div>
      </nav>

      <main className="shell__main">
        <Outlet />
      </main>
    </div>
  );
}
